import axios from 'axios';
import moment from 'moment';
import * as type from '../types';

const api = axios.create({
    baseURL: process.env.VUE_APP_PDF_API
})

export default {
    namespaced: true,
    state: {
        headers: [
            { text: 'Date Created', value: 'createdAt', sortable: true, formatter: (row) => moment(row.createdAt).utcOffset('+08:00').format('MM/DD/YYYY, hh:mm A') },
            { text: 'Batch ID', value: 'batchId', sortable: true },
            { text: 'User', value: 'userName', sortable: true },
            { text: 'Type', value: 'pdfType', sortable: true },
            { text: 'Page Count', value: 'pageCount', sortable: true, formatter: (row) => row.pageCount === 0 ? '-' : row.pageCount },
            { text: 'Status', value: 'status', sortable: true, formatter: (row) => row.status === 2 ? 'Success' : row.status === 3 ? 'Error' : ''},
            { text: 'Actions', value: '', align: 'center', alignHeader: 'center', width: '200' }
        ],
        items: [],
        loading: false,
        uploadHeaders: [
            { text: 'Filename', value: 'originalName', sortable: true },
            { text: 'Size', value: 'size', sortable: true, width: '200' },
            { text: 'Page Count', value: 'pageCount', sortable: true, width: '200' },
            { text: 'Actions', value: '', align: 'center', alignHeader: 'center', width: '200' }
        ],
        uploadItems: [],
        uploadLoading: false
    },
    getters:{
        getHeaders: state => state.headers,
        getItems: state => state.items,
        getLoading: state => state.loading,

        getUploadHeaders: state => state.uploadHeaders,
        getUploadItems: state => state.uploadItems,
        getUploadLoading: state => state.uploadLoading
    },
    mutations: {
        setLoading: (state, payload) => state.loading = payload,
        setUploadLoading: (state, payload) => state.uploadLoading = payload,
        [type.PDF_GET_LOGS]: (state, payload) => state.items = payload,
        [type.PDF_ADD_LOGS]: (state, payload) => state.items.unshift(payload),
        [type.PDF_UPLOAD]: (state, payload) => state.uploadItems.unshift(payload),
        [type.PDF_UPLOAD_DELETE]: (state, payload) => state.uploadItems = state.uploadItems.filter(e => e.filepath !== payload.filepath),
        [type.PDF_UPLOAD_CLEAR]: state => state.uploadItems = []
    },
    actions: {
        [type.PDF_UPLOAD]: async ({commit}, payload) => {
            commit('setUploadLoading', true);
            try {
                let response = await api.post(`/pdf/upload`, payload);
                commit(type.PDF_UPLOAD, response.data[0]);
            } catch (error) {
                console.log(error);
            }finally{
                commit('setUploadLoading', false);
                return Promise.resolve()
            }
        },
        [type.PDF_UPLOAD_DELETE]: ({commit}, payload) => {
            try {
                commit(type.PDF_UPLOAD_DELETE, payload)
            } finally{
                return Promise.resolve()
            }
        },
        [type.PDF_UPLOAD_CLEAR]: ({commit}) => {
            try {
                commit(type.PDF_UPLOAD_CLEAR)
            } finally{
                return Promise.resolve()
            }
        },
        [type.PDF_GET_LOGS]: async ({commit}) => {
            commit('setLoading', true);
            try {
                let response = await api.get('/pdf');
                commit(type.PDF_GET_LOGS, response.data);
            } catch (error) {
                console.log(error)
            }finally{
                commit('setLoading', false);
            }
        },
        [type.PDF_ADD_LOGS]: async ({commit}, payload) => {
            commit('setLoading', true);
            try {
                let response;
                if(payload.pdfType === 1){
                    response = await api.post('/pdf/merge', payload);
                }else if(payload.pdfType === 2){
                    response = await api.post('/pdf/split', payload);
                }
                commit(type.PDF_ADD_LOGS, response.data.result);
                return Promise.resolve(response.data.message);
            } catch (error) {
                console.log(error)
                return Promise.reject(error);
            }finally{
                commit('setLoading', false);
            }
        }
    }
}